import React from 'react';
import { observer } from 'mobx-react';

import { WatchedAsset } from '@kaltura-ott/tvpil-shared';

import { Card, CardBubbleInfo, CardInner, CardTitle } from 'components/presenters';
import { WIDGET_TYPE } from 'consts';

import ContinueWatchingCardContent from './components/ContinueWatchingCardContent/ContinueWatchingCardContent';
import { useContinueWatchingCard } from './hooks/useContinueWatchingCard/useContinueWatchingCard';

interface Props {
  item: WatchedAsset;
  itemWidth: number;
  imageHeight: number;
}

function ContinueWatchingCard({ item, itemWidth, imageHeight }: Props) {
  const {
    link,
    title,
    isAdult,
    isRecord,
    progress,
    ariaLabel,
    handleRef,
    clickHandler,
    onMouseEnter,
    onMouseLeave,
    contentMarker,
    handleLinkRef,
    isSeriesRecord,
    handleClickInfo,
    defaultImageUrl,
    seasonEpisodeTitle,
    backgroundImageUrl,
    shouldDisplayPlayButton,
    shouldDisplayContentMarker,
  } = useContinueWatchingCard({ item, itemWidth, imageHeight });

  return (
    <Card
      handleLinkRef={handleLinkRef}
      clickHandler={clickHandler}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      link={link}
      ariaLabel={ariaLabel}
      imageHeight={imageHeight}
      itemWidth={itemWidth}
      isMosaicProgram={false}
    >
      <CardInner
        cardType={WIDGET_TYPE.CW}
        url={backgroundImageUrl}
        name={item.title}
        defaultImageUrl={defaultImageUrl}
        handleRef={handleRef}
        handleLinkRef={handleLinkRef}
        isAdult={isAdult}
        isNoDataWithNoLogoImg={false}
        contentOverlay={
          <ContinueWatchingCardContent
            shouldDisplayContentMarker={shouldDisplayContentMarker}
            contentMarker={contentMarker}
            shouldDisplayPlayButton={shouldDisplayPlayButton}
            progress={progress}
          />
        }
      />
      <CardBubbleInfo
        channelHasProgram
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        isAdult={isAdult}
        title={title}
        isMosaicProgram={false}
        handleClickInfo={handleClickInfo}
        seasonEpisodeTitle={seasonEpisodeTitle}
        isLinkAsAsset={false}
      />
      <CardTitle
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        seasonEpisodeTitle={seasonEpisodeTitle}
        isAdult={isAdult}
        isStaticInfo
        title={title}
        isMosaicProgram={false}
      />
    </Card>
  );
}

export default observer(ContinueWatchingCard);
